import RichTextEditor from "./components/richTextEditor/richTextEditor";
import SortableTable from "./components/sortableTable/sortableTable";

document.querySelectorAll("[data-module='fds-rich-text-editor']")
  .forEach(module => new RichTextEditor(module));

document.querySelectorAll("[data-module='fds-sortable-table']")
  .forEach(module => new SortableTable(module));
